import Cookies from "universal-cookie";
import { fetchWrapper, history } from "@/_helpers";
import { userLogoutSuccess } from "../_redux/actions/accountActions";
import * as apiUtils from "../_api/apiUtils";

const baseUrl = process.env.API_URL + "/Users/";
const cookies = new Cookies();

export const accountService = {
  login,
  loginCE,
  logout,
  refreshToken,
  register,
  verifyEmail,
  forgotPassword,
  sendResetEmail,
  resetCode,
  resetCodeVerify,
  validateResetToken,
  resetPassword,
  resetProfilePassword,
};

function login(UserName, Password, isPhone) {
  return fetchWrapper
    .post(`${baseUrl}authenticate`, { UserName, Password, isPhone })
    .then((user) => {
      // publish user to subscribers and start timer to refresh token
      cookies.set("lifesaferUser", JSON.stringify(user), {
        path: "/",
        sameSite: "strict",
      });
      //startRefreshTokenTimer();
      return user;
    });
}

function loginCE(EnrollmentCode) {
  return fetchWrapper
    .get(`${baseUrl}CEAuthentication?SecretKey=${EnrollmentCode}`)
    .then((user) => {
      if(user.userId !== undefined) {
        // publish user to subscribers and start timer to refresh token
        cookies.set("lifesaferUser", JSON.stringify(user), {
          path: "/",
          sameSite: "strict",
        });
        return user;
      }
      return undefined;
    });
}

function logout() {
  // revoke token, stop refresh timer, publish null to user subscribers and redirect to login page
  //fetchWrapper.post(`${baseUrl}/revoke-token`, {});
  //stopRefreshTokenTimer();
  cookies.remove("lifesaferUser", { path: "/" }); //Remove cookies
  userLogoutSuccess(); //Remove state objects
  window.Five9SocialWidget.removeWidget() // remove the chat widget on logout
  history.push("/account/login");
}

function refreshToken() {
  return fetchWrapper.post(`${baseUrl}refresh-token`, {}).then((user) => {
    // start timer to refresh token
    //startRefreshTokenTimer();
    return user;
  });
}

function register(params) {
  return fetchWrapper.post(`${baseUrl}/register`, params);
}

function verifyEmail(token) {
  return fetchWrapper.post(`${baseUrl}/verify-email`, { token });
}

// function forgotPassword(emailAddress) {
//   return fetchWrapper
//     .post(`${baseUrl}ForgotPassword`, { emailAddress })
//     .then((rtn) => {
//       return rtn;
//     });
// }

function forgotPassword(emailObj ) {
  return fetchWrapper
    .post(`${baseUrl}ForgotPassword`,emailObj)
    .then((rtn) => {
      return rtn;
    });
}

function sendResetEmail(emailObj) {
  return fetchWrapper
    .post(`${baseUrl}ResetEmail`,emailObj)
    .then((rtn) => {
      //rtn="message:Sent/Both"
      return rtn;
    });
}

function resetCode(emailObj) {
  return apiUtils
    .post(`${baseUrl}ResetCode`,emailObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

function resetCodeVerify(emailObj) {
  return fetchWrapper
    .post(`${baseUrl}ResetCodeVerify`,emailObj)
    .then((rtn) => {
      return rtn;
    });
}

function validateResetToken(userID, token) {
  return apiUtils
    .post(`${baseUrl}ValidateResetToken`, { userID, token })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

function resetPassword(userID, token, password) {
  return apiUtils
    .post(`${baseUrl}ResetPassword`, { userID, token, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

function resetProfilePassword(userID, password) {
  return apiUtils
    .post(`${baseUrl}ResetUserPassword`, { userID, password })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

// helper functions
// let refreshTokenTimeout;

// function startRefreshTokenTimer() {
//   // parse json object from base64 encoded jwt token
//   //const jwtToken = JSON.parse(atob(userSubject.value.jwtToken.split(".")[1]));
//   // set a timeout to refresh the token a minute before it expires
//   // const expires = new Date(jwtToken.exp * 1000);
//   // const timeout = expires.getTime() - Date.now() - 60 * 1000;
//   // refreshTokenTimeout = setTimeout(refreshToken, timeout);
// }

// function stopRefreshTokenTimer() {
//   clearTimeout(refreshTokenTimeout);
// }
